import React from 'react';
import i18n from 'i18next';

import { ListHeader, ListBody, ListEmpty } from '@/exceed';

import useVideoViews from '../hooks/useVideoViews';

import VideosAdminMetricsCardRow from './videosAdminMetricsCardRow';
import VideosAdminViewDataRow from './videosAdminViewDataRow';
import styles from '../styles/videosAdminViews.module.scss';

const VideosAdminViews = () => {
  const { data: { data, meta, pagination } = {}, isFetching } = useVideoViews();
  const totalRecords = pagination?.total_records;
  const totalLikes = meta?.total_likes;
  const totalDislikes = meta?.total_dislikes;
  const percentViewed = meta?.average_percentage_viewed;

  return (
    <>
      <VideosAdminMetricsCardRow
        metrics={[
          { id: 1, name: i18n.t('total-unique-views'), value: totalRecords },
          { id: 2, name: i18n.t('total-likes'), value: totalLikes },
          { id: 3, name: i18n.t('total-dislikes'), value: totalDislikes },
          { id: 4, name: i18n.t('average-percentage-viewed'), value: (percentViewed >= 0 && `${percentViewed}%`) || undefined },
        ]}
      />
      <ListHeader
        rowClassName={styles.widerSecondColumn}
        columns={[i18n.t('started'), i18n.t('amount-watched'), i18n.t('version')]}
        title={i18n.t('views')}
        nameText={i18n.t('user')}
        nameMetaText={totalRecords !== undefined ? i18n.t('num-returned', { num: totalRecords }) : ''}
      />
      <ListBody
        data={data}
        emptyComponent={(
          <ListEmpty
            title={i18n.t('no-results-found')}
          />
        )}
        ListItem={VideosAdminViewDataRow}
        hasPagination
        isLoading={isFetching}
        isUngrouped
        totalPages={pagination?.total_pages}
      />
    </>
  );
};

export default React.memo(VideosAdminViews);
